import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Heading } from '@/components/ui/typography';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Stack } from '@/components/ui/layout';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

function Projects({ onUpdate, existingProjects = [] }) {
  const [projects, setProjects] = useState(existingProjects || []);


  useEffect(() => {
    onUpdate(projects);
  }, [projects]);

  const handleChange = (index, field, value) => {
    const updatedProjects = [...projects];
    updatedProjects[index][field] = value;
    setProjects(updatedProjects);
  };

  const addProject = () => {
    setProjects([...projects, { projectName: '', projectDescription: '' }]);
  };

  const deleteProject = (index) => {
    const updatedProjects = projects.filter((_, i) => i !== index);
    setProjects(updatedProjects);
  };

  return (
    <Card className="mb-6 bg-white">
      <CardContent className="p-4">
        <Heading level="h2" className="text-base font-semibold mb-3">Projects</Heading>
        <Stack spacing="md">
          {projects.map((project, index) => (
            <div key={index} className={cn("space-y-4 p-4 border rounded-lg")}>
              <div>
                <Label htmlFor={`projectName${index}`}>Project Name</Label>
                <Input
                  type="text"
                  id={`projectName${index}`}
                  value={project.projectName}
                  onChange={(e) => handleChange(index, 'projectName', e.target.value)}
                  placeholder="Ex. Project Name"
                  className="mt-1"
                />
              </div>
              <div>
                <Label htmlFor={`projectDescription${index}`}>Description</Label>
                <Textarea
                  id={`projectDescription${index}`}
                  value={project.projectDescription}
                  onChange={(e) => handleChange(index, 'projectDescription', e.target.value)}
                  placeholder="Write project description here..."
                  className="mt-1"
                />
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => deleteProject(index)}
                className="text-destructive self-end"
              >
                <X className="w-4 h-4 mr-2" />
                Delete Project
              </Button>
            </div>
          ))}
          <Button variant="outline" onClick={addProject} className="w-full">
            Add Project
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default Projects;